
import VGPopUp from "components/Controls/VGPopUp";
import MultiLocationCheckSelectWrapper from "components/Multilocation/MultiLocationCheckSelectWrapper";
import { Fragment, useState } from "react";
import {  unmountComponentAtNode } from "react-dom";

export function SaveMultilocation({ allLocation_data, selectedLocation_data, BusinessID, CurrencySymbol, PlanAmount, locationPlan, saveLocation, selectedLocationMethod }: { allLocation_data: any, selectedLocation_data: any, BusinessID: any, CurrencySymbol: any, PlanAmount: any, locationPlan: any, saveLocation: Function, selectedLocationMethod: Function }) {

    const [pAmount, setPAmount] = useState(PlanAmount);
    const [selectedLocationData, setSelectedLocationData] = useState(selectedLocation_data);

    const MultilocationselectionId = (data: any) => {

        const dataArray = data.filter((item: any, index: any) => data.indexOf(item) === index);

        if (dataArray.length > 0) {
            let filterChild: any = [];
            //eslint-disable-next-line
            dataArray.map((d: any, j: any) => {
                if (d != "" && d != "-1") {
                    filterChild.push(d);
                }
            });
            if (locationPlan.length > 0) {
                //eslint-disable-next-line
                if (filterChild.length > 0) {//eslint-disable-next-line
                    locationPlan.map((d: any, j: any) => { //eslint-disable-next-line
                        if (d.fromPlan <= filterChild.length && d.toPlan >= filterChild.length) {
                            setPAmount(d.charges);
                        }
                    });
                }
                else {
                    //eslint-disable-next-line
                    locationPlan.map((d: any, j: any) => { //eslint-disable-next-line
                        if (d.fromPlan <= 1 && d.toPlan >= 1) {
                            setPAmount(d.charges);
                        }
                    });
                }
            }
        }
        else {
            //eslint-disable-next-line
            if (locationPlan.length > 0) { //eslint-disable-next-line
                locationPlan.map((d: any, j: any) => {
                    if (d.fromPlan <= 1 && d.toPlan >= 1) {
                        setPAmount(d.charges);
                    }
                });
            }
        }
        setSelectedLocationData(dataArray);
        selectedLocationMethod(dataArray);
    }

    const PopupSecondClose = () => {
        let dom = document.getElementById("OpenDialog2");
        if (dom) unmountComponentAtNode(dom);
    };

    return (
        <VGPopUp
            id={"ActivateMultipleLocationPopup"}
            show={true}
            onHide={PopupSecondClose}
            title={"Include Locations for MySite"}
            dialogClassName="cancelauto-renew-alert"
            body={
                <div className="alertContent h-full">
            
                    <MultiLocationCheckSelectWrapper defaultBID={BusinessID} allLocation={allLocation_data} selectedLocations={selectedLocationData}
                        updateFunc={MultilocationselectionId} forceSelected={BusinessID}
                    />
                </div>
            }
            footer={
                <Fragment>
                    <button className="w-button w-button-secondary" onClick={() => PopupSecondClose()}>Cancel</button>
                    <button className="w-button w-button-primary" onClick={() => { saveLocation(2); }}>Publish {CurrencySymbol}{pAmount}/mo</button>
                </Fragment >
            }
            isRemoveTabModalIndex={false}
            isShowFooter={true}
            size={"md"}
            backdrop={true}
        />
    )
}